module.exports = __webpack_public_path__ + "static/media/file.6cbc0ce8.svg";